export const facilityIcons = {
  駐車場: "🅿️",
  屋外プール: "🏊",
  室内プール: "🏊",
  プール: "🏊",
  ダイビング: "🤿",
  シュノーケリング: "🐠",
  スパ: "💆",
  マッサージ: "💆",
  マッサージルーム: "💆",
  手荷物預かり: "🧳",
  レストラン: "🍽️",
  バー: "🍸",
  レンタカー: "🚗",
  "Wi-Fi": "📶",
  WiFi: "📶",
  サウナ: "🧖",
  ジム: "🏋️",
  フィットネス: "🏋️",
  キッズクラブ: "🧒",
  送迎: "🚐",
  BBQ: "🍖",
  コインランドリー: "🧺",
};

export const getFacilityIcon = (facility) => facilityIcons[facility] || "✓";
